import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import { Grid, Row, Col } from 'shared/components'
import { Select } from 'shared/components/input/components/select'
import * as styles from './styles'

import { getOptionLabel, getOptionValue } from './helpers'

const LinkedSelectComponent = ({
  sportType,
  tournament,
  loadingTournaments,
  loadingSportTypes,
  tournamentOptions,
  sportTypeOptions,
  onSportTypeInput,
  onTournamentInput,
  onChangeSportType,
  onChangeTournament,
  iconOptioned,
  size,
}) => {
  const tournamentPlaceholder = sportType
    ? `${sportType.name} Tournament`
    : 'Select Tournament'

  const getTournamentLabel = useCallback(
    ({ tournamentName: name }) =>
      sportType ? `${sportType.name}: ${name}` : name,
    [sportType]
  )

  return (
    <Grid>
      <Row css={styles.rowHeight}>
        <Col xs={12} sm={6}>
          <Select
            fluid
            isSearchable
            isClearable
            placeholder="Select Sport"
            value={sportType}
            isLoading={loadingSportTypes}
            getOptionLabel={getOptionLabel}
            getOptionValue={getOptionValue}
            options={sportTypeOptions}
            onInputChange={onSportTypeInput}
            onChange={onChangeSportType}
            css={styles.select}
            iconOptioned={iconOptioned}
            size={size}
          />
        </Col>
        <Col xs={12} sm={6}>
          <Select
            fluid
            isSearchable
            isClearable
            value={tournament}
            placeholder={tournamentPlaceholder}
            isLoading={loadingTournaments}
            getOptionLabel={getTournamentLabel}
            getOptionValue={getOptionValue}
            options={tournamentOptions}
            onInputChange={onTournamentInput}
            onChange={onChangeTournament}
            size={size}
          />
        </Col>
      </Row>
    </Grid>
  )
}

LinkedSelectComponent.propTypes = {
  sportType: PropTypes.shape({
    name: PropTypes.shape(),
  }),
  tournament: PropTypes.shape({
    name: PropTypes.string,
  }),
  loadingTournaments: PropTypes.bool,
  loadingSportTypes: PropTypes.bool,
  sportTypeOptions: PropTypes.arrayOf(PropTypes.shape()),
  tournamentOptions: PropTypes.arrayOf(PropTypes.shape()),
  onSportTypeInput: PropTypes.func,
  onTournamentInput: PropTypes.func,
  onChangeSportType: PropTypes.func,
  onChangeTournament: PropTypes.func,
  iconOptioned: PropTypes.bool,
  size: PropTypes.string,
}

export default LinkedSelectComponent
